module.exports = __webpack_public_path__ + "static/img/blog-details.a1d9ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/blog-details.jpg
// module id = sAU5
// module chunks = 36